import { ProcessDocumentAws } from 'domain/usecases/document/process-document-aws'
import { AwsDocumentRepository } from 'repository/interfaces/aws-document-repository'

export class RemoteProcessDocumentAws implements ProcessDocumentAws {
  private readonly documentRepository: AwsDocumentRepository

  constructor(documentRepository: AwsDocumentRepository) {
    this.documentRepository = documentRepository
  }

  process(
    params: ProcessDocumentAws.Params
  ): Promise<ProcessDocumentAws.Model> {
    return this.documentRepository.processDocumentAws(params)
  }
}

export type ProcessDocumentAwsModel = ProcessDocumentAws.Model
